import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

export default {
    namespaced: true,
    getters,
    mutations,
    actions,
    state
}


// export default {
//     // state
// 	state: {
//         auth: (localStorage.getItem('auth'))?true:false,
//         notify: 0,
//         dataUser: {}
// 	},

//     // getters
// 	getters: {
//         getAuthFormGetter(state){ //take parameter state
//             return state.auth
//         },
//         getNotifyGetter(state){ //take parameter state
//             return state.notify
//         },
//         getDataUser(state) {
//             return state.dataUser
//         }
// 	},

//     // actions
// 	actions: {
//         checkAuthUser(context){
//             axios.get("/if-auth")
//             .then((response)=>{
//                 // console.log(response)
//                 context.commit('changeStatusAuth', response.data[0]) //auth will be run from mutation
//                 if (response.data[0]) {
//                     localStorage.setItem('name', response.data[1])
//                     localStorage.setItem('auth', 1)
//                     context.commit('changeContNotify', response.data[2])
//                 } else {
//                     localStorage.removeItem('name')
//                     localStorage.removeItem('auth')
//                 }
//             })
//             .catch(()=>{
//                 console.log("Error........")
//             })
//         },
//         // show user
//         showPerfilUser(context, userId){
//             if (userId) {
//                 axios.post('/perfil-public', {userId: userId})
//                 .then((response) => {
//                     // console.log(response)
//                     context.commit('respUser', response.data)
//                 })
//                 .catch((error) => {
//                     console.log('Error.......')
//                 })
//             }
//         }
// 	},

//     // mutations
// 	mutations: {
//         changeStatusAuth(state, data) {
//             return state.auth = data
//         },
//         changeContNotify(state, data) {
//             return state.notify = data
//         },
//         // user perfil
//         respUser(state, data) {
//             return state.dataUser = data
//         }
// 	}
// }